module.exports = __webpack_public_path__ + "img/w15-b1.47089c85.jpg";